import { primitiveTokens } from "@appretio/ui-kit";
import { style } from "@vanilla-extract/css";

export const tableControlsContainer = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"],
  justifyContent: "space-between"
});

export const tableControlsLeft = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["2x"]
});

export const tableControlsRight = style({
  display: "flex",
  alignItems: "center",
  gap: primitiveTokens.sizing["1x"]
});

/**
 * Fixed like the forecast bar's View slot, but without its viewport cap: the
 * left group is content-sized, so a percentage cap would shrink the picker
 * to nothing.
 */
export const viewPickerSlot = style({
  display: "flex",
  flex: "0 0 21rem",
  minWidth: 0
});
